export const enAiBrandMonitoringTranslations = {
    AI_BRAND_MONITORING__TITLE: 'AI Brand Monitoring',
    AI_BRAND_MONITORING__BRAND_SELECT__LABEL: 'Brand',
    AI_BRAND_MONITORING__SELECT_BRAND_PROMPT: 'Select a brand to view AI brand monitoring.',

    // onboarding
    AI_BRAND_MONITORING__ONBOARDING__TITLE: 'Set up AI brand monitoring',
    AI_BRAND_MONITORING__ONBOARDING__DESCRIPTION:
        'Track how AI assistants mention your brand. Configure prompts, competitors and models to get started.',
    AI_BRAND_MONITORING__ONBOARDING__NO_PERMISSION: 'You do not have permission to configure monitoring.',

    // settings
    AI_BRAND_MONITORING__SETTINGS__TITLE: 'Monitoring settings',
    AI_BRAND_MONITORING__SETTINGS__ENABLED: 'Enable monitoring',
    AI_BRAND_MONITORING__SETTINGS__PROMPTS: 'Prompts',
    AI_BRAND_MONITORING__SETTINGS__PROMPT_PLACEHOLDER:
        'For example: Recommend a reliable grocery delivery service in Moscow',
    AI_BRAND_MONITORING__SETTINGS__ADD_PROMPT: 'Add prompt',
    AI_BRAND_MONITORING__SETTINGS__PROMPT_REQUIRED: 'Prompt text is required',
    AI_BRAND_MONITORING__SETTINGS__PROMPTS_LIMIT: 'Maximum number of prompts reached',
    AI_BRAND_MONITORING__SETTINGS__PROMPT_HINT_TITLE:
        'Enter questions your customers ask about your niche — without mentioning your brand name.',
    AI_BRAND_MONITORING__SETTINGS__PROMPT_HINT_EXAMPLE_1:
        'Which grocery delivery services are the most reliable in Moscow?',
    AI_BRAND_MONITORING__SETTINGS__PROMPT_HINT_EXAMPLE_2: 'Recommend a CRM for a small business',
    AI_BRAND_MONITORING__SETTINGS__PROMPT_HINT_EXAMPLE_3: 'Where is the best place to buy running shoes online?',
    AI_BRAND_MONITORING__SETTINGS__PROMPT_HINT_NO_BRAND:
        'Do not include your brand name in the question — we measure whether the AI mentions it on its own.',
    AI_BRAND_MONITORING__SETTINGS__COMPETITORS: 'Competitors',
    AI_BRAND_MONITORING__SETTINGS__COMPETITORS_PLACEHOLDER: 'Select competitors',
    AI_BRAND_MONITORING__SETTINGS__COMPETITORS_NO_AVAILABLE: 'Add brand competitors in the Competitors section first.',
    AI_BRAND_MONITORING__SETTINGS__SAVE: 'Save settings',
    AI_BRAND_MONITORING__SETTINGS__SAVED: 'Settings saved',
    AI_BRAND_MONITORING__SETTINGS__SAVE_ERROR: 'Failed to save settings',
    AI_BRAND_MONITORING__SETTINGS__READ_ONLY: 'You can view but not edit these settings.',

    // config errors
    AI_BRAND_MONITORING__ERROR__LIMIT_EXCEEDED: 'A configured limit was exceeded.',
    AI_BRAND_MONITORING__ERROR__UNSUPPORTED_MODEL: 'One of the selected models is not supported.',
    AI_BRAND_MONITORING__ERROR__NOT_CONFIGURED: 'Monitoring is not configured yet.',
    AI_BRAND_MONITORING__ERROR__UNKNOWN_COMPETITOR: 'One of the selected competitors is not available.',

    // credits

    // run
    AI_BRAND_MONITORING__RUN__BUTTON: 'Run now',
    AI_BRAND_MONITORING__RUN__CONFIRM_TITLE: 'Start a monitoring run?',
    AI_BRAND_MONITORING__RUN__CONFIRM_OK: 'Run',
    AI_BRAND_MONITORING__RUN__CONFIRM_CANCEL: 'Cancel',
    AI_BRAND_MONITORING__RUN__IN_PROGRESS: 'A run is already in progress.',
    AI_BRAND_MONITORING__RUN__STARTED: 'Run completed.',
    AI_BRAND_MONITORING__RUN__ERROR: 'Failed to start the run.',

    AI_BRAND_MONITORING__RUN_STATUS__QUEUED: 'Queued',
    AI_BRAND_MONITORING__RUN_STATUS__RUNNING: 'Running',
    AI_BRAND_MONITORING__RUN_STATUS__SUCCESS: 'Success',
    AI_BRAND_MONITORING__RUN_STATUS__PARTIAL: 'Partial',
    AI_BRAND_MONITORING__RUN_STATUS__FAILED: 'Failed',

    // dashboard
    AI_BRAND_MONITORING__DASHBOARD__NO_RUNS: 'No runs yet. Start your first run to see results.',
    AI_BRAND_MONITORING__DASHBOARD__RUN_IN_PROGRESS: 'Analysis in progress. Results will appear here once it finishes.',
    AI_BRAND_MONITORING__DASHBOARD__BRAND_SCORE: 'Brand score',
    AI_BRAND_MONITORING__DASHBOARD__YOUR_BRAND: 'Your brand',
    AI_BRAND_MONITORING__DASHBOARD__VISIBILITY_SCORE: 'Visibility Score',
    AI_BRAND_MONITORING__DASHBOARD__SCORE_DYNAMICS: 'Score dynamics',
    AI_BRAND_MONITORING__DASHBOARD__RECOMMENDATIONS: 'Recommendations',
    AI_BRAND_MONITORING__DASHBOARD__NO_RECOMMENDATIONS: 'No recommendations available.',
    AI_BRAND_MONITORING__DASHBOARD__NO_DATA: 'No data available.',

    // overview
    AI_BRAND_MONITORING__OVERVIEW__TITLE: 'Overview',
    AI_BRAND_MONITORING__OVERVIEW__INSIGHT:
        'Your brand is ranked {rank} of {total} by visibility. AI assistants recommend "{competitor}" most often.',
    AI_BRAND_MONITORING__OVERVIEW__INSIGHT_LEADER: 'Your brand is the visibility leader.',
    AI_BRAND_MONITORING__OVERVIEW__INSIGHT_NO_COMPETITORS: 'Add competitors to compare your visibility.',

    // tables
    AI_BRAND_MONITORING__TABLE__DELTA: 'Change',
    AI_BRAND_MONITORING__TABLE__DELTA_TOOLTIP: 'Difference from the previous run. ▲ up, ▼ down, «—» first run.',
    AI_BRAND_MONITORING__TABLE__NAME: 'Name',

    // answers
    AI_BRAND_MONITORING__ANSWERS__TITLE: 'Answers',
    AI_BRAND_MONITORING__ANSWERS__PROMPT: 'Prompt',
    AI_BRAND_MONITORING__ANSWERS__POSITION: 'Position',
    AI_BRAND_MONITORING__ANSWERS__EXCLUDED: 'Excluded from scoring',
    AI_BRAND_MONITORING__ANSWERS__NO_ANSWERS: 'No answers for this run.',
    AI_BRAND_MONITORING__ANSWERS__MENTIONED: 'Mentioned',
    AI_BRAND_MONITORING__ANSWERS__NOT_MENTIONED: 'Not mentioned',
    AI_BRAND_MONITORING__ANSWERS__SENTIMENT_POSITIVE: 'Positive',
    AI_BRAND_MONITORING__ANSWERS__SENTIMENT_NEUTRAL: 'Neutral',
    AI_BRAND_MONITORING__ANSWERS__SENTIMENT_NEGATIVE: 'Negative',
    AI_BRAND_MONITORING__ANSWERS__COMPETITORS: 'Competitors',

    // v2 tabs
    AI_BRAND_MONITORING__TABS__BRAND_ANALYSIS: 'Brand analysis',
    AI_BRAND_MONITORING__TABS__PROMPT_MENTIONS: 'Prompt mentions',

    // v2 brand analysis
    AI_BRAND_MONITORING__ANALYSIS__SOURCE_NOTE: 'Based on AI web search',
    AI_BRAND_MONITORING__ANALYSIS__NO_DATA: 'No brand analysis for this run.',
    AI_BRAND_MONITORING__ANALYSIS__VISIBILITY: 'Visibility in AI',
    AI_BRAND_MONITORING__ANALYSIS__VISIBILITY_TOOLTIP:
        '0–100. How present and discoverable the brand is on the web according to AI web search — the share of the ' +
        'selected signals that were found.',
    AI_BRAND_MONITORING__ANALYSIS__TONALITY: 'Tonality',
    AI_BRAND_MONITORING__ANALYSIS__TONALITY_TOOLTIP:
        '0–100. How AI speaks about the brand, averaged over the tonality aspects (positive → high, negative → low).',
    AI_BRAND_MONITORING__ANALYSIS__SIGNALS_FOUND: '{found} of {total} signals found',
    AI_BRAND_MONITORING__ANALYSIS__VISIBILITY_TITLE: 'Visibility',
    AI_BRAND_MONITORING__ANALYSIS__SOURCES: 'Sources',
    AI_BRAND_MONITORING__ANALYSIS__TONALITY_TITLE: 'Tonality',
    AI_BRAND_MONITORING__ANALYSIS__ASPECTS_HINT: 'Aspects are selected by the model for the brand industry',
    AI_BRAND_MONITORING__ANALYSIS__POSITIONING_TITLE: 'Positioning',
    AI_BRAND_MONITORING__ANALYSIS__STRENGTHS: 'Strengths',
    AI_BRAND_MONITORING__ANALYSIS__WEAKNESSES: 'Weaknesses',
    AI_BRAND_MONITORING__ANALYSIS__NO_SOURCES: 'no sources found',
    AI_BRAND_MONITORING__ANALYSIS__DYNAMICS: 'Dynamics',

    // v2 visibility signals
    AI_BRAND_MONITORING__SIGNAL__OFFICIAL_SITE: 'Official website',
    AI_BRAND_MONITORING__SIGNAL__SOCIALS: 'Social networks',
    AI_BRAND_MONITORING__SIGNAL__DIRECTORIES: 'Business directories and marketplaces',
    AI_BRAND_MONITORING__SIGNAL__REVIEWS: 'Customer reviews',
    AI_BRAND_MONITORING__SIGNAL__MEDIA: 'Media and publications',
    AI_BRAND_MONITORING__SIGNAL__COMMUNITIES: 'Communities and forums',

    // v2 tonality labels
    AI_BRAND_MONITORING__TONALITY__POSITIVE: 'Positive',
    AI_BRAND_MONITORING__TONALITY__NEUTRAL: 'Neutral',
    AI_BRAND_MONITORING__TONALITY__MIXED: 'Mixed',
    AI_BRAND_MONITORING__TONALITY__NEGATIVE: 'Negative',

    // v2 prompt mentions
    AI_BRAND_MONITORING__PROMPTS__INTRO:
        'Set your own prompts — for each one we check the AI answer: whether the brand is mentioned, its position, ' +
        'sentiment and which competitors are named.',

    // v2 settings
    AI_BRAND_MONITORING__SETTINGS__VISIBILITY_SIGNALS: 'Visibility sources',
    AI_BRAND_MONITORING__SETTINGS__VISIBILITY_SIGNALS_HINT:
        'Which signals to include in the visibility analysis. The score is the share of found signals among the ' +
        'selected ones.',
    AI_BRAND_MONITORING__SETTINGS__ASPECT_MODE: 'Tonality aspects',
    AI_BRAND_MONITORING__SETTINGS__ASPECT_MODE_AUTO: 'Automatic — the model selects aspects for the brand industry',
    AI_BRAND_MONITORING__SETTINGS__ASPECT_MODE_CUSTOM: 'Custom — from your review aspects (up to 5)',
    AI_BRAND_MONITORING__SETTINGS__ASPECTS_PLACEHOLDER: 'Select aspects',
    AI_BRAND_MONITORING__SETTINGS__ASPECTS_HINT: 'Taken from your review aspects.',
    AI_BRAND_MONITORING__SETTINGS__ASPECTS_NO_AVAILABLE: 'No review aspects configured for this brand yet.',

    // v2 config errors
    AI_BRAND_MONITORING__ERROR__INVALID_SIGNALS: 'Select at least one visibility source.',
    AI_BRAND_MONITORING__ERROR__ASPECTS_REQUIRED: 'Select at least one tonality aspect.',
    AI_BRAND_MONITORING__ERROR__TOO_MANY_ASPECTS: 'Too many tonality aspects selected.',
};
